const PARENTHESIZED_EXPRESSION = /\(([^()\n]{1,80})\)/g;
const PROTECTED_INLINE_MATH = /(\\\([^\n]*?\\\)|\$[^$\n]*\$)/g;
const LATEX_COMMAND = /\\[A-Za-z]+/;
const SIMPLE_RELATION = /^[A-Za-z](?:_\{?[A-Za-z0-9]+\}?)?\s*(?:=|≈|<|>|≤|≥|\\(?:le|ge|approx))\s*[-+]?[A-Za-z0-9\\{}.^/ ]+$/;

function looksLikeGeneratedMath(value) {
  const candidate = value.trim();
  if (!candidate || candidate.includes('$')) {
    return false;
  }
  return LATEX_COMMAND.test(candidate)
    || SIMPLE_RELATION.test(candidate);
}

function normalizePlainFeedbackSegment(value) {
  return value.replace(PARENTHESIZED_EXPRESSION, (match, candidate) => (
    looksLikeGeneratedMath(candidate) ? `$${candidate.trim()}$` : match
  ));
}

// Generated feedback can contain either TeX `\(...\)` delimiters or bare
// parenthesised expressions. Markdown only recognises `$...$`, so normalise
// explicit TeX and the narrow set of bare expressions we can identify safely.
export function normalizeGeneratedFeedbackMarkdown(value) {
  if (typeof value !== 'string' || !value) {
    return value;
  }

  return value
    .split(PROTECTED_INLINE_MATH)
    .map((segment) => {
      if (segment.startsWith('\\(') && segment.endsWith('\\)')) {
        return `$${segment.slice(2, -2).trim()}$`;
      }
      if (segment.startsWith('$') && segment.endsWith('$')) {
        return segment;
      }
      return normalizePlainFeedbackSegment(segment);
    })
    .join('');
}
